export const getWidth = element => element ? element.getBoundingClientRect().width : 0;
//# sourceMappingURL=utils.js.map